// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { useTranslation } from 'react-i18next';
import { OperatorType } from 'util/Enums';
import _snakeCase from 'lodash/snakeCase';

type ProcessTagProps = {
  stage: OperatorType;
};

const TAG_COLOR_MAP: {
  [key in OperatorType]?: string;
} = {
  [OperatorType.Emissions]: '#F75354',
  [OperatorType.Compressions]: '#F7FF9E',
  [OperatorType.Recycle]: '#008DF9',
  [OperatorType.Producer]: '#7B14F9',
  [OperatorType.Purchase]: '#97E75B',
} as const;

const ProcessTag: React.FC<ProcessTagProps> = ({ stage }) => {
  const { t } = useTranslation();

  if (!TAG_COLOR_MAP[stage]) {
    return null;
  }

  return (
    <div
      style={{
        color: TAG_COLOR_MAP[stage],
        padding: '2px 4px',
        border: `1px solid ${TAG_COLOR_MAP[stage]}`,
        borderRadius: '4px',
        fontSize: '14px',
        display: 'inline-block',
      }}
    >
      {t(`purchase_page.trace_data_detail.stages.${_snakeCase(stage)}`, {
        defaultValue: stage,
      })}
    </div>
  );
};

export default ProcessTag;
